import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconBasketball32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconBasketball32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M15 17v8.95a9.96 9.96 0 0 1-5.47-2.325A12.94 12.94 0 0 0 11.962 17zm2 0v8.95a9.96 9.96 0 0 0 5.47-2.325A12.94 12.94 0 0 1 20.038 17zm3.038-2H17V6.05a9.96 9.96 0 0 1 5.47 2.325A12.94 12.94 0 0 0 20.038 15m2.007 2c.17 1.9.824 3.658 1.837 5.155A9.95 9.95 0 0 0 25.95 17zm3.906-2a9.95 9.95 0 0 0-2.07-5.155A10.9 10.9 0 0 0 22.046 15zM15 15h-3.038A12.94 12.94 0 0 0 9.53 8.375 9.96 9.96 0 0 1 15 6.049zm-5.045 0a10.9 10.9 0 0 0-1.837-5.155A9.95 9.95 0 0 0 6.05 15zM6.05 17a9.95 9.95 0 0 0 2.07 5.155A10.9 10.9 0 0 0 9.954 17zm-2.008 0C4.55 23.16 9.71 28 16 28c6.627 0 12-5.373 12-12S22.627 4 16 4C9.71 4 4.55 8.84 4.041 15H4v2z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconBasketball32);
